import React from 'react';
import { connect } from 'react-redux';
import {push} from "react-router-redux";
import {Link} from "react-router";
import { NotificationManager } from 'react-notifications';

import UserRoles from "../../../../../common/src/enums/UserRoles";
import {ROUTE_CLUB, ROUTE_CLUBS, ROUTE_SECTIONS, ROUTE_SECTION, ROUTE_RACE} from '../../../constants/routeconstants';
import * as AdminActions from "../../../actions/admin";

import { confirm } from '../../../utils/confirmDialog';

class SectionsPage extends React.Component {

    static getId() {
        return ROUTE_SECTIONS;
    }

    static getAllowedRoles() {
        return [UserRoles.CLUB_ADMIN, UserRoles.MAIN_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.dispatch(AdminActions.getSections());
    }

    render() {
        return this.props.admin.isSectionsRead?
            <div>
                <div className="sub-page-title">
                    <h2>Sektioner</h2>
                </div>
                <div className="sub-page-content">
                    <table className="data-table">
                        <thead>
                        <tr>
                            <th scope="row">Nr</th>
                            <th>Navn</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.props.admin.sections.sort((c1, c2) => c1.Sektionsnr < c2.Sektionsnr ? -1 : 1).toArray().map(section => {
                            //const updates = section.UpdateRequests.find(update => update.type === 'club') || null;
                            return <tr key={section.Sektionsnr} /*className={updates === null ? '' : (updates.key === null ? 'new' : (updates.deleted ? 'deleted' : 'updated'))}*/ onDoubleClick={() => {
                                this.props.dispatch(push(ROUTE_SECTION.replace(':sectionNo', section.Sektionsnr).replace(':subpage', 'general').replace(':mode', 'view')));
                            }}>
                                <th scope="row">{section.Sektionsnr}</th>
                                <td>{section.Navn}</td>
                                <td>
                                    <Link to={ROUTE_SECTION.replace(':sectionNo', section.Sektionsnr).replace(':subpage', 'general').replace(':mode', 'view')} title="Vis detaljer">
                                        <i className="fa fa-file-text-o"/>
                                    </Link>

                                    <Link to={ROUTE_SECTION.replace(':sectionNo', section.Sektionsnr).replace(':subpage', 'general').replace(':mode', 'edit')} title="Rediger sektion">
                                        <i className="fa fa-pencil"/>
                                    </Link>
                                    <i className={"fa fa-trash pointer"} title="Slet sektion" onClick={() => {
                                        confirm("Slet", <span>Ønsker du at slette sektion <b>{section.Sektionsnr} ({section.Navn})</b>?</span>, () => {
                                            this.props.dispatch(AdminActions.deleteSection(section.Sektionsnr, () => {
                                                NotificationManager.success("Sektion " + section.Sektionsnr + " (" + section.Navn + ") er slettet.", "Sletning", 4000);
                                            }));
                                        });
                                    }}/>
                                </td>
                            </tr>
                        })}
                        </tbody>
                    </table>
                </div>
                <div className="sub-page-actions">
                    <Link className={"btn-primary"} to={ROUTE_SECTION.replace(':sectionNo', 'new').replace(':subpage', 'general').replace(':mode', 'create')} title="Opret ny sektion">
                        Ny
                    </Link>
                </div>
            </div> : null;
    }
}

const mapStateToProps = (state) => ({
    admin: {
        isSectionsRead: state.admin.isSectionsRead,
        sections: state.admin.sections
    }
});

export default connect(mapStateToProps)(SectionsPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/section/SectionsPage.js